<template>
  <div
    v-mm-spinner="{
      visible: loading,
    }"
    class="xm-invoice"
  >
    <h2>{{ $t('invoice.myInvoice') }}</h2>
    <mm-alert
      v-if="needRedInvoiceList.length > 0"
      type="warning"
      :closable="false"
    >
      <template #title>
        <span>
          {{ $t('invoice.pendingRedInvoiceWarning') }}
          <a
            v-for="(item, index) in needRedInvoiceList"
            :key="item"
            class="need-red-invoice-link"
            @click="handleViewDetail(item)"
          >{{ `${index > 0 ? '、' : ''}${item}` }}</a>
        </span>
      </template>
    </mm-alert>
    <invoice-list-table
      style="margin-top: 20px;"
      :list-data="listData"
      :columns="columns"
    >
      <template #operation="{ row }">
        <a
          class="operator-link"
          @click="handleViewDetail(row.order_no)"
        >{{ $t('invoice.viewDetail') }}</a>
      </template>
    </invoice-list-table>
  </div>
</template>

<script>
import InvoiceApi from '@api/invoice'
import InvoiceListTable from './components/InvoiceListTable.vue'
import { INVOICE_LIST_COLUMNS } from './constants'

export default {
  name: 'Invoice',
  components: {
    InvoiceListTable
  },
  data() {
    return {
      listData: [],
      columns: INVOICE_LIST_COLUMNS,
      needRedInvoiceList: [],
      loading: false,
    }
  },
  created() {
    this.fetchInvoiceList()
  },
  methods: {
    async fetchInvoiceList() {
      this.loading = true

      try {
        const data = await InvoiceApi.fetchInvoiceList()
        
        if(!data || !Object.keys(data).length) return
        
        this.listData = data.list
        this.needRedInvoiceList = data.need_red
      } finally {
        this.loading = false
      }
    },


    handleViewDetail(orderNo) {
      this.$router.push({
        path: `/invoice/detail/${orderNo}`,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.xm-invoice {
  padding: 20px;

  .need-red-invoice-link {
    cursor: pointer;
  }
  .operator-link {
    cursor: pointer;
  }
  h2 {
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  :deep(.mm-tfixed__right .mm-tbody table) {
    min-width: 205px;
  }
}
</style>